import React from 'react'
import './hero.styles.css';
const Hero = () => {
  return (
    <div className='hero-container'>
        <h1>Tap into the full <br/>potential of crypto</h1>
        <p>Earn secure yields on your crypto, using new age strategies.</p>
        <button className='start-learning'>Start earning</button>
    </div>
  )
}

export default Hero